<template>
  <div id="app-wrapper">
    <menu-nav class="app-sidebar" v-bind:style="isShowSecondMenu ? 'width:200px;':'width:90px;'"> </menu-nav>
    <app-container v-bind:style="isShowSecondMenu ? 'margin-left:200px;':'margin-left:90px;'"> </app-container>
  </div>
</template>

<script>

import MenuNav from "./components/MenuNav";
import AppContainer from "./components/AppContainer"

export default {
  name: "layout",
  components: {
    MenuNav,
    AppContainer
  },
  computed: {
    currentRoute() {
      for(var i=0; i < this.$router.options.routes.length; i++)
      {
        var router = this.$router.options.routes[i]
        if (this.$route.path === router.path) {
          return router
        } else if (this.$route.path.indexOf(router.path+'/') === 0) {
          return router
        }
      }
      return null
    },
    isShowSecondMenu() {
      return this.currentRoute && this.currentRoute.children && (this.currentRoute.children.length>1 || this.currentRoute.alwaysShow)
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue